import { IEditRolePayload, IGetRoleList, IRoleCreate, IRoleDetails, IRoleListSearch } from "../../../types/master/roleInterface";
import { RoleActionTypes, RoleActions } from "../../actionTypes/master/roleActionTypes";

export const createRole = (payload: IRoleCreate): RoleActionTypes => ({
  type: RoleActions.CREATE_ROLE,
  payload,
});

export const getRoleList = (payload: IRoleListSearch): RoleActionTypes => ({
  type: RoleActions.GET_ROLE_LIST,
  payload,
});

export const setRoleList = (branchList: Array<IGetRoleList>) : RoleActionTypes => ({
  type: RoleActions.SET_ROLE_LIST,
  payload: branchList
})

export const setRoleListPageCount = (payload:number): RoleActionTypes => ({
  type: RoleActions.SET_ROLE_LIST_PAGE_COUNT,
  payload
})

export const getRoleDataById = (id: number | string): RoleActionTypes => ({
  type: RoleActions.GET_ROLE_DATA_BY_ID,
  payload: id
})

export const setRoleDataById = (payload: IRoleDetails): RoleActionTypes => ({
  type: RoleActions.SET_ROLE_DATA_BY_ID,
  payload
})

export const editRole = (payload: IEditRolePayload): RoleActionTypes => ({
  type: RoleActions.EDIT_ROLE_DATA_BY_ID,
  payload,
});

export const setDepartmentId = (payload: number): RoleActionTypes => ({
  type: RoleActions.SET_DEPARTMENT_ID,
  payload,
});